import { render, staticRenderFns } from "./internal-remark.modal.vue?vue&type=template&id=3aa58101&"
import script from "./internal-remark.modal.vue?vue&type=script&lang=ts&"
export * from "./internal-remark.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports